import * as React from "react";

interface Props {
  children: React.ReactNode;
  errorMessage: string;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public loadComponentRetried = "load-component-retried";

  public retryLoadComponent = () => {
    const loadComponentHasAlreadyRetried = JSON.parse(
      window.localStorage.getItem(this.loadComponentRetried) || "false"
    ) as boolean;

    if (!loadComponentHasAlreadyRetried) {
      window.localStorage.setItem(this.loadComponentRetried, "true");
      this.setState({ hasError: false });
      window.location.reload();
    } else {
      window.localStorage.setItem(this.loadComponentRetried, "false");
      this.setState({ hasError: true });
    }
  };

  public componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    this.retryLoadComponent();
    console.error("Loading component error:", error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return <span>{this.props.errorMessage}</span>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
